export const REDIS_KEYS = Object.freeze({
  CATEGORY_COMPUTED_LABELS: "CATEGORY_COMPUTED_LABELS",
  PRESALE_PERCENTAGE: "PRESALE_PERCENTAGE",
});
